@if (panelOpen()) {
  <app-slide-panel [open]="panelOpen()" [title]="isEditing() ? 'Edit User' : 'Add New User'" (closed)="closePanel()"
      class="flex-1 text-[#141437] dark:text-white"
      panelClass="min-w-[600px] lg:min-w-[700px] max-w-[800px] h-full flex flex-col overflow-hidden card-bg border-l border-[#EAEAEA] dark:border-line">
      <form [formGroup]="form" (ngSubmit)="submitForm()" class="flex flex-col flex-1 overflow-hidden h-full">
          <section class="flex flex-col gap-8 flex-1 overflow-y-auto p-6">
              <!-- Account Details Section -->
              <div class="space-y-4">
                  <h3 class="text-md font-semibold text-slate-800 dark:text-white border-b border-slate-100 dark:border-slate-800 pb-2 mb-6">
                      Account Details </h3>
                  <div class="grid grid-cols-2 gap-4">
                      <app-input variant="themeBase" placeholder="Enter first name" label="First Name"
                          formControlName="firstName" [error]="getErrorMessage('firstName')" [maxlength]="50"
                          (keydown)="preventLeadingSpace($event)"
                          (valueChange)="onInputChange('firstName')"></app-input>
                      <app-input variant="themeBase" placeholder="Enter last name" label="Last Name"
                          formControlName="lastName" [error]="getErrorMessage('lastName')" [maxlength]="50"
                          (keydown)="preventLeadingSpace($event)"
                          (valueChange)="onInputChange('lastName')"></app-input>
                  </div>

                  <div class="grid grid-cols-2 gap-4">
                      <app-input variant="themeBase" placeholder="john.doe@example.com" label="Email"
                          formControlName="email" [error]="getErrorMessage('email')"
                          (keydown)="preventLeadingSpace($event)"
                          (valueChange)="onInputChange('email')"></app-input>
                      <app-input variant="themeBase" placeholder="Enter phone number" label="Phone Number"
                          formControlName="phoneNumber" [error]="getErrorMessage('phoneNumber')" [maxlength]="15"
                          (keydown)="preventLeadingSpace($event)"
                          (valueChange)="onInputChange('phoneNumber')"></app-input>
                  </div>

              </div>

              @if (isRequest()) {
                <div class="space-y-4">
                    <h3 class="text-md font-semibold text-slate-800 dark:text-white border-b border-slate-100 dark:border-slate-800 pb-2 mb-6">
                        Approval Reason <span class="text-red-500">*</span>
                    </h3>
                    <div class="w-full">
                        <textarea class="w-full flex min-h-[100px] rounded-xl bg-white dark:bg-surface-0 px-4 py-3 text-[14px] border focus:outline-none focus:ring-2 focus:ring-offset-0 transition-all duration-200 resize-y text-slate-800 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 custom-scrollbar"
                            [ngClass]="getErrorMessage('note') ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20 dark:border-red-500/50 dark:focus:border-red-500' : 'border-slate-200 focus:border-[#AD46FF] focus:ring-[#AD46FF]/20 dark:border-white/5 dark:focus:border-purple-500'"
                            formControlName="note"
                            (input)="onInputChange('note')"
                            placeholder="Add a note for approving this request"></textarea>
                        
                        @if (getErrorMessage('note')) {
                            <div class="mt-1 flex items-center gap-1 min-h-[16px]">
                                <app-icon name="circleAlert" [size]="12" class="text-red-500"></app-icon>
                                <span class="text-[11px] font-medium text-red-500 whitespace-nowrap">{{ getErrorMessage('note') }}</span>
                            </div>
                        }
                    </div>
                </div>
                }

              <!-- Security Section -->
              <div class="space-y-4">
                  <h3 class="text-md font-semibold text-slate-800 dark:text-white border-b border-slate-100 dark:border-slate-800 pb-2 mb-6">
                      Security </h3>
                  <div class="w-full">
                      <div class="flex flex-col gap-2">
                          <label class="text-sm font-medium text-slate-600 dark:text-ink-muted">2FA Enabled</label>
                          <div class="flex items-center h-[42px]">
                              <app-toggle formControlName="isTwoFAEnabled"
                                  label="Enable Two-Factor Authentication"></app-toggle>
                          </div>
                      </div>
                  </div>
              </div>

              <!-- Access & Config Section -->
              <div class="space-y-4">
                  <h3 class="text-md font-semibold text-slate-800 dark:text-white border-b border-slate-100 dark:border-slate-800 pb-2 mb-6">
                      Access & Config </h3>
                  <div [ngClass]="isEditing() ? 'grid grid-cols-2 gap-4' : 'w-full'">
                      <div class="flex flex-col gap-2">
                          <label class="text-sm font-medium text-slate-600 dark:text-ink-muted">Role</label>
                          <app-dropdown [options]="roleOptions" variant="themeBase" formControlName="roleId"
                              placeholder="Select Role" [fullWidth]="true" [error]="getErrorMessage('roleId')"
                              chevronIcon="chevronDown"></app-dropdown>
                      </div>
                      @if (isEditing()) {
                      <div class="flex flex-col gap-2">
                          <label class="text-sm font-medium text-slate-600 dark:text-ink-muted">Status</label>
                          <app-dropdown [options]="formStatusOptions" variant="themeBase" formControlName="status"
                              placeholder="Select Status" [fullWidth]="true" [error]="getErrorMessage('status')"
                              chevronIcon="chevronDown"></app-dropdown>
                      </div>
                      }
                  </div>
              </div>

              <!-- Product Access Section -->
              <div class="space-y-4">
                  <h3 class="text-md font-semibold text-slate-800 dark:text-white border-b border-slate-100 dark:border-slate-800 pb-2 mb-6">
                      Product Based Access Management
                  </h3>
                  
                  <div class="bg-slate-50 dark:bg-surface-0 border border-slate-200 dark:border-white/5 rounded-3xl overflow-hidden shadow-sm dark:shadow-2xl flex flex-col">
                      <!-- Segmented Toggle Header -->
                      <div class="p-2 flex gap-1 bg-white dark:bg-surface-2 border-b border-slate-200 dark:border-white/5">
                          <button type="button"
                              (click)="form.get('productAccessType')?.setValue('ALL_PRODUCTS'); onInputChange('productAccessType')"
                              [class]="form.get('productAccessType')?.value === 'ALL_PRODUCTS' ? 'bg-[#AD46FF] text-white shadow-[0_0_20px_rgba(173,70,255,0.3)]' : 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-white/5 hover:text-slate-700 dark:hover:text-slate-200'"
                              class="flex-1 py-3 text-xs font-bold rounded-2xl transition-all duration-300 ease-out uppercase tracking-wider">
                              Full Access
                          </button>
                          <button type="button"
                              (click)="form.get('productAccessType')?.setValue('LIMITED_PRODUCTS'); onInputChange('productAccessType')"
                              [class]="form.get('productAccessType')?.value === 'LIMITED_PRODUCTS' ? 'bg-[#AD46FF] text-white shadow-[0_0_20px_rgba(173,70,255,0.3)]' : 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-white/5 hover:text-slate-700 dark:hover:text-slate-200'"
                              class="flex-1 py-3 text-xs font-bold rounded-2xl transition-all duration-300 ease-out uppercase tracking-wider">
                              Limited Access
                          </button>
                      </div>

                      <!-- Header Info (Only show for Limited Access) -->
                      @if (form.get('productAccessType')?.value === 'LIMITED_PRODUCTS') {
                          <div class="p-6 bg-slate-50/50 dark:bg-white/[0.01] border-b border-slate-200 dark:border-white/5">
                              <div class="flex items-center justify-between text-[11px] font-black text-slate-500 uppercase tracking-widest px-1">
                                  <span>Product Name</span>
                                  <div class="flex items-center gap-2">
                                      <span>Toggle Access</span>
                                      <button type="button"
                                          (click)="toggleAllProductsLocal()"
                                          class="text-[#AD46FF] hover:text-[#AD46FF]/80 normal-case font-bold ml-2 cursor-pointer">
                                          {{ isAllProductsSelected() ? 'Unselect All' : 'Select All' }}
                                      </button>
                                  </div>
                              </div>
                          </div>
                      }

                      <!-- Scrollable Product List (Only show for Limited Access) -->
                      @if (form.get('productAccessType')?.value === 'LIMITED_PRODUCTS') {
                          <div class="max-h-[380px] overflow-y-auto custom-scrollbar bg-white dark:bg-surface-0">
                              @for (product of filteredProducts(); track product.id) {
                              <div
                                  (click)="onProductToggle(product)"
                                  class="px-6 py-5 flex items-center justify-between border-b border-slate-100 dark:border-white/[0.03] transition-all cursor-pointer hover:bg-slate-50 dark:hover:bg-white/[0.02]">
                                  
                                  <div class="flex items-center gap-4">
                                      <div class="w-12 h-12 rounded-2xl bg-slate-50 dark:bg-white/5 flex items-center justify-center text-[#AD46FF] border border-slate-200 dark:border-white/10 shadow-inner group-hover:scale-110 transition-transform duration-300">
                                          <app-icon name="zap" [size]="20"></app-icon>
                                      </div>
                                      <div class="flex flex-col">
                                          <span class="text-[14px] font-bold tracking-tight text-slate-800 dark:text-white">{{ product.name || product.displayName || product.label }}</span>
                                          <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium">Standard License</span>
                                      </div>
                                  </div>

                                  <div class="flex items-center">
                                      <div class="w-7 h-7 rounded-xl border-2 transition-all duration-300 flex items-center justify-center"
                                          [ngClass]="{
                                              'bg-[#AD46FF] border-[#AD46FF] shadow-[0_0_15px_rgba(173,70,255,0.4)]': isProductSelected(product),
                                              'border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/5': !isProductSelected(product)
                                          }">
                                          @if (isProductSelected(product)) {
                                              <app-icon name="check" [size]="16" class="text-white fill-white"></app-icon>
                                          }
                                      </div>
                                  </div>
                              </div>
                              } @empty {
                                  <div class="py-16 text-center">
                                      <div class="w-16 h-16 mx-auto mb-4 bg-slate-50 dark:bg-white/5 rounded-full flex items-center justify-center text-slate-300 dark:text-slate-700">
                                          <app-icon name="search" [size]="24"></app-icon>
                                      </div>
                                      <p class="text-sm text-slate-500 dark:text-slate-400 font-medium">No products found matching your search</p>
                                  </div>
                              }
                          </div>
                      }

                      <!-- Intelligent Info Bar -->
                      <div class="bg-slate-50 dark:bg-surface-2 p-5 border-t border-slate-200 dark:border-white/5">
                          @if (form.get('productAccessType')?.value === 'ALL_PRODUCTS') {
                              <div class="flex gap-3 items-center text-[#10B981]">
                                  <div class="w-2.5 h-2.5 rounded-full bg-[#10B981] shadow-[0_0_8px_#10B981]"></div>
                                  <span class="text-[12px] font-bold leading-tight">Universal access enabled. All platform capabilities are unlocked.</span>
                              </div>
                          } @else {
                              <div class="flex justify-between items-center">
                                  <span class="text-[12px] text-slate-500 dark:text-slate-400 font-bold italic">
                                      {{ selectedCount() }} of {{ allProducts().length }} products selected
                                  </span>
                              </div>
                          }
                      </div>
                  </div>
              </div>

          </section>

          <!-- Footer -->
          <div
              class="grid grid-cols-2 gap-4 p-5 sticky bottom-0 bg-white dark:bg-surface-1 border-t border-[#EAEAEA] dark:border-line mt-auto">
              <app-button type="button" variant="defaultBorder" (buttonClick)="closePanel()"
                  className="w-full h-[45px]">
                  Cancel
              </app-button>
              <app-button type="submit" variant="default" className="w-full h-[45px]" [disabled]="isLoading()">
                  {{ isLoading() ? 'Saving...' : 'Save' }}
              </app-button>
          </div>
      </form>
  </app-slide-panel>
  }
